(function () {
  "use strict";

  const MANIFEST_SELECTOR = "[data-de-preorder-variants]";
  const MAIN_PRODUCT_SELECTOR = '[data-ui-component="Main Product Section"]';
  const MAIN_FORM_SELECTOR = ".js-main-product-form";
  const CHECKOUT_SELECTOR = "[data-de-dynamic-checkout]";
  const ADD_BUTTON_SELECTOR = ".js-product-form-submit-btn";
  const ADD_BUTTON_TEXT_SELECTOR = ".js-product-form-submit-btn-text";
  const PROPERTY_MARKER = "data-de-preorder-property";
  const PROPERTY_NAMES = {
    preorder: "Vorbestellung",
    item: "Vorbestellter Artikel",
    dispatch: "Voraussichtlicher Versand",
    split: "Separate Teillieferungen möglich"
  };

  let updateTimer = 0;
  let observer = null;

  function clean(value) {
    return String(value || "").trim();
  }

  function readManifestElement() {
    return document.querySelector(MANIFEST_SELECTOR);
  }

  function readManifest() {
    const element = readManifestElement();
    if (!element) return {};

    try {
      return JSON.parse(element.textContent || "{}");
    } catch (error) {
      console.error("[ALLPOWERS DE Vorbestellung] Ungültige Variant-Daten", error);
      return {};
    }
  }

  function getProductSection() {
    return document.querySelector(MAIN_PRODUCT_SELECTOR);
  }

  function getForm() {
    return getProductSection()?.querySelector(MAIN_FORM_SELECTOR) || null;
  }

  function getPurchaseForms() {
    return Array.from(
      document.querySelectorAll(
        `${MAIN_PRODUCT_SELECTOR} ${MAIN_FORM_SELECTOR}, #productStickyForm`
      )
    );
  }

  function getVariantId(form) {
    return clean(form?.querySelector('input[name="id"]')?.value);
  }

  function currentData(form) {
    const variantId = getVariantId(form);
    const data = readManifest()[variantId] || null;
    return { variantId, data, isPreorder: data?.enabled === true };
  }

  function parseDate(value) {
    if (!value) return null;
    const parts = String(value).split("-").map(Number);
    if (parts.length !== 3 || parts.some((part) => !part)) return null;
    return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
  }

  function datePeriod(date) {
    if (!date) return "";
    const day = date.getUTCDate();
    const period = day <= 10 ? "Anfang" : day <= 20 ? "Mitte" : "Ende";
    const month = new Intl.DateTimeFormat("de-DE", {
      month: "long",
      timeZone: "UTC"
    }).format(date);
    return `${period} ${month}`;
  }

  function effectiveDate(data) {
    if (!data) return null;
    if (data.dispatchStart) return parseDate(data.dispatchStart);

    const item = clean(data.itemType).toLowerCase();
    if (
      item.includes("solar") ||
      item.includes("panel") ||
      item.includes("solarmodul")
    ) {
      return parseDate(data.solarPanelStart || data.powerStationStart);
    }

    if (
      item.includes("power") ||
      item.includes("station") ||
      item.includes("speicher")
    ) {
      return parseDate(data.powerStationStart || data.solarPanelStart);
    }

    return parseDate(data.powerStationStart || data.solarPanelStart);
  }

  function shippingText(data) {
    const period = datePeriod(effectiveDate(data));
    if (period) return `ab ${period}`;
    if (clean(data?.contactNote)) return clean(data.contactNote);
    return "Termin auf Anfrage";
  }

  function removeProperties(form) {
    form
      ?.querySelectorAll(`[${PROPERTY_MARKER}="true"]`)
      .forEach((element) => element.remove());
  }

  function addProperty(form, name, value) {
    if (!form || !clean(value)) return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${name}]`;
    input.value = clean(value);
    input.setAttribute(PROPERTY_MARKER, "true");
    form.appendChild(input);
  }

  function syncProperties(form, data, isPreorder) {
    removeProperties(form);
    if (!isPreorder) return;

    addProperty(form, PROPERTY_NAMES.preorder, "Ja");
    addProperty(form, PROPERTY_NAMES.item, data.itemType);
    addProperty(form, PROPERTY_NAMES.dispatch, shippingText(data));
    if (data.splitShipping === true) {
      addProperty(form, PROPERTY_NAMES.split, "Ja");
    }
  }

  function syncPropertiesBeforeSubmit(event) {
    const submittedForm = event.target;
    if (!(submittedForm instanceof HTMLFormElement)) return;
    if (
      !submittedForm.matches(MAIN_FORM_SELECTOR) &&
      submittedForm.id !== "productStickyForm"
    ) {
      return;
    }

    const mainForm = getForm();
    if (!mainForm) return;
    const { data, isPreorder } = currentData(mainForm);

    syncProperties(mainForm, data || {}, isPreorder);
    if (submittedForm !== mainForm) {
      syncProperties(submittedForm, data || {}, isPreorder);
    }
  }

  function syncButtons(section, data, isPreorder) {
    const checkout = section?.querySelector(CHECKOUT_SELECTOR);
    const addButton = section?.querySelector(ADD_BUTTON_SELECTOR);
    const buttonText = addButton?.querySelector(ADD_BUTTON_TEXT_SELECTOR);

    if (checkout) {
      checkout.hidden = isPreorder;
      checkout.classList.toggle("d-none-important", isPreorder);
      checkout.setAttribute("aria-hidden", isPreorder ? "true" : "false");
    }

    if (!addButton) return;
    if (!addButton.dataset.deOriginalButtonClasses) {
      addButton.dataset.deOriginalButtonClasses = "true";
      addButton.dataset.deOriginalPrimary = addButton.classList.contains(
        "btn-primary"
      )
        ? "true"
        : "false";
      addButton.dataset.deOriginalSecondary = addButton.classList.contains(
        "btn-secondary"
      )
        ? "true"
        : "false";
    }

    if (isPreorder) {
      addButton.classList.add("btn-primary");
      addButton.classList.remove("btn-secondary");
    } else {
      addButton.classList.toggle(
        "btn-primary",
        addButton.dataset.deOriginalPrimary === "true"
      );
      addButton.classList.toggle(
        "btn-secondary",
        addButton.dataset.deOriginalSecondary === "true"
      );
    }
    addButton.dataset.dePreorder = isPreorder ? "true" : "false";

    if (buttonText && !buttonText.dataset.deOriginalText) {
      buttonText.dataset.deOriginalText = clean(buttonText.textContent);
    }

    if (buttonText) {
      if (isPreorder) {
        buttonText.textContent = "JETZT VORBESTELLEN";
      } else if (buttonText.dataset.deOriginalText) {
        buttonText.textContent = buttonText.dataset.deOriginalText;
      }
    }

    if (isPreorder && data?.available === false) {
      addButton.disabled = false;
      addButton.removeAttribute("aria-disabled");
    }
  }

  function ensureBadge(section) {
    let badge = section?.querySelector("[data-de-preorder-badge]");
    if (badge) return badge;

    const gallery = section?.querySelector(
      ".product-slideshow__slider, .product__media-wrapper"
    );
    if (!gallery) return null;

    badge = document.createElement("div");
    badge.className = "de-preorder-badge";
    badge.setAttribute("data-de-preorder-badge", "true");
    badge.setAttribute("role", "note");
    badge.innerHTML = [
      '<strong class="de-preorder-badge__title">VORBESTELLUNG</strong>',
      '<span class="de-preorder-badge__item" data-de-preorder-badge-item></span>',
      '<span class="de-preorder-badge__label">Voraussichtlicher Versand</span>',
      '<span class="de-preorder-badge__date" data-de-preorder-badge-date></span>'
    ].join("");
    gallery.appendChild(badge);
    return badge;
  }

  function syncBadge(section, data, isPreorder) {
    const badge = ensureBadge(section);
    if (!badge) return;

    badge.hidden = !isPreorder;
    if (!isPreorder) return;

    const item = badge.querySelector("[data-de-preorder-badge-item]");
    const date = badge.querySelector("[data-de-preorder-badge-date]");
    if (item) {
      item.textContent = clean(data.itemType);
      item.hidden = !clean(data.itemType);
    }
    if (date) date.textContent = shippingText(data);
  }

  function dispatchState(variantId, isPreorder) {
    document.documentElement.classList.toggle(
      "de-preorder-selected",
      isPreorder
    );
    document.dispatchEvent(
      new CustomEvent("de:preorder:change", {
        detail: { variantId, isPreorder }
      })
    );
  }

  function update() {
    const section = getProductSection();
    const form = getForm();
    if (!section || !form) return;

    const { variantId, data, isPreorder } = currentData(form);
    getPurchaseForms().forEach((purchaseForm) => {
      syncProperties(purchaseForm, data || {}, isPreorder);
    });
    syncButtons(section, data || {}, isPreorder);
    syncBadge(section, data || {}, isPreorder);
    dispatchState(variantId, isPreorder);
  }

  function scheduleUpdate() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(update, 80);
  }

  function bind() {
    const section = getProductSection();
    const form = getForm();
    if (!section || !form) return;

    if (section.dataset.dePreorderLinkageReady !== "true") {
      section.dataset.dePreorderLinkageReady = "true";
      section.addEventListener("change", scheduleUpdate);
      section.addEventListener("click", scheduleUpdate);
      document.addEventListener("submit", syncPropertiesBeforeSubmit, true);
    }

    observer?.disconnect();
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      observer = new MutationObserver(scheduleUpdate);
      observer.observe(idInput, {
        attributes: true,
        attributeFilter: ["value", "disabled"]
      });
    }

    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  document.addEventListener("shopify:section:load", bind);
})();
